import TemplateNames from './TemplateNames';

export default {
  title: 'Mensagens enviadas',
  columns: {
    recipient: 'Destinatário',
    template: 'Modelo',
    status: 'Estado',
    opened: 'Aberto',
    clicked: 'Clicado',
    sent_at: 'Enviado em',
  },
  labels: {
    empty_list: 'Nenhuma mensagem enviada ainda',
    load_failed: 'Não foi possível carregar as suas mensagens enviadas. Recarregue a página ou contacte o suporte.',
    yes: 'Sim',
    no: 'Não',
    clicked_at: 'Clicado em: {{date}}',
    opened_at: 'Aberto em: {{date}}',
  },
  message_statuses: {
    sent: 'Enviado',
    delivered: 'Entregue',
    failed: 'Com falha',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_load_data: 'Erro ao carregar dados',
  },
};
